export default "__VITE_ASSET__Ctc7RJxU__"